import { useEffect, useState } from "react";
import api from "../lib/api";
import ImageUpload from "../components/ImageUpload";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminGallery() {
  const [items, setItems] = useState([]);
  const [newUrl, setNewUrl] = useState("");
  const [alt, setAlt] = useState("");

  const load = () => api.get("/gallery").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!newUrl) return toast.error("Upload an image first");
    try {
      await api.post("/gallery", { url: newUrl, alt, sort_order: items.length });
      toast.success("Added to gallery");
      setNewUrl(""); setAlt("");
      load();
    } catch { toast.error("Failed to add"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Remove this photo from gallery?")) return;
    await api.delete(`/gallery/${id}`);
    load();
  };

  return (
    <div data-testid="admin-gallery-page">
      <h1 className="font-serif-display text-4xl text-[#5979A9] mb-2">Gallery</h1>
      <p className="text-[#4A5568] text-sm mb-7">Upload new photos to feature on your website.</p>

      <form onSubmit={add} className="bg-white rounded-2xl border border-[#F0EAE6] p-6 mb-8 space-y-5">
        <ImageUpload value={newUrl} onChange={setNewUrl} testid="gallery-upload"/>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-[#5979A9]/80 mb-2 font-semibold">Alt text (optional)</label>
          <input value={alt} onChange={(e) => setAlt(e.target.value)} placeholder="e.g. Pad Thai with prawns"
                 className="w-full bg-transparent border-b-2 border-[#F0EAE6] focus:border-[#E05947] outline-none py-2"/>
        </div>
        <button type="submit" data-testid="gallery-add-button" className="btn-primary">Add to gallery</button>
      </form>

      <div className="columns-2 lg:columns-3 gap-4 space-y-4">
        {items.map((g) => (
          <div key={g.id} className="break-inside-avoid relative group rounded-2xl overflow-hidden border border-[#F0EAE6]">
            <img src={g.url} alt={g.alt || ""} className="w-full h-auto"/>
            <button onClick={() => remove(g.id)} data-testid={`gallery-delete-${g.id}`}
                    className="absolute top-2 right-2 bg-white/95 text-[#E05947] rounded-full p-2 shadow opacity-0 group-hover:opacity-100 transition-opacity">
              <Trash2 size={14}/>
            </button>
          </div>
        ))}
        {items.length === 0 && <p className="text-[#4A5568] col-span-full">No photos yet.</p>}
      </div>
    </div>
  );
}
